/* eslint-disable no-shadow */
import axios from "axios";
import router from "@/router";
import store from "@/store";
import { getCookie, deleteCookie, setCookie } from "@/auth/CookiesManager";
import { getClientIpAddress } from "./clientIp";
//import { environment } from '../environments/environment'
// console.log("VUE_APP_PRODUCTION", process.env.VUE_APP_PRODUCTION);
const domain =
  process.env.VUE_APP_PRODUCTION == "true"
    ? process.env.VUE_APP_API_URL_PROD
    : process.env.VUE_APP_API_URL_DEV;

const AUDITED_METHODS = new Set(["post", "put", "delete"]);

/*
 * Global Axios Request Interceptor
 */
const request = async (request) => {
  try {
    request.headers = request.headers || {};
    request.headers.common = request.headers.common || {};

    const tokenFromSession =
      store.state.appConfig.sessionContext?.token || null;
    const tokenFallback =
      store.state.appConfig.token || getCookie("token") || null;
    const token = tokenFromSession || tokenFallback;
    if (token) {
      request.headers.common.Authorization = `Bearer ${token}`;
    }

    const method = String(request.method || "").toLowerCase();
    const idUser =
      store.state.appConfig.sessionContext?.idUser ??
      store.state.appConfig.idUser ??
      getCookie("idUser") ??
      null;
    const normalizedIdUser = String(idUser ?? "").trim();

    if (AUDITED_METHODS.has(method) && normalizedIdUser) {
      request.headers.common.idUser = normalizedIdUser;

      const ipAddress = await getClientIpAddress();
      if (ipAddress) {
        request.headers.common.ipAddress = ipAddress;
      }
    }

    return request;
  } catch (err) {
    console.error("Request Interceptor Error:", err);
    return Promise.reject(err);
  }
};

/*
 * Global Axios Response Interceptor
 */
const response = async (response) => response;
/*
 * Global Axios Response Interceptor when Error
 */
const error = async (error) => {
  const { status, data } = error?.response || {};
  // Si la API devuelve un error 401 (sin autorización)
  if (status === 401) {
    const message = data?.message || "No autenticado";
    deleteCookie("token");
    deleteCookie("role");
    deleteCookie("user");
    deleteCookie("guidCompany");
    deleteCookie("idUser");
    deleteCookie("idCatTypeProfile");
    deleteCookie("menuPermissions");
    deleteCookie("divisa");
    deleteCookie("idCompany");
    deleteCookie("tasaDolar");
    deleteCookie("dolarBCV");
    deleteCookie("guidProfile");
    deleteCookie("famcos");
    deleteCookie("companyType");
    setCookie("logout", true);

    store.commit("appConfig/SET_RESET_TOKEN");
    store.commit("appConfig/SET_RESET_ROLE");
    store.commit("appConfig/SET_RESET_STATE");
    store.commit("appConfig/SET_RESET_DIVISA");
    store.commit("appConfig/SET_RESET_MENU_PERMISSIONS");
    store.commit("appConfig/SET_RESET_USER_ID");
    store.commit("appConfig/SET_RESET_ID_CAT_TYPE_PROFILE");
    store.commit("appConfig/SET_RESET_ID_COMPANY");
    store.commit("appConfig/SET_RESET_SESSION_CONTEXT");
    store.commit("appConfig/CLEAR_ACTIVE_COMPANY");

    document.cookie = "logout=true; path=/; SameSite=Lax";
    sessionStorage.removeItem("app-session");
    sessionStorage.removeItem("session-minimal");

    console.error("Error 401 - Unauthorized:", data?.message || "Unauthorized");
    router.push("/login").catch(() => {});
    return Promise.reject(new Error(message));
  }
  // Si la API devuelve un error 400 (mala solicitud), podemos extraer el mensaje y lanzarlo
  if (status === 400) {
    const message = data?.message || "Bad Request";
    // const errorMessage = new Error(data.message || 'Bad Request')
    console.error("Error 400 - Bad Request:", data?.message || "Bad request");
    // data = errorMessage
    return Promise.reject(new Error(message));
  }
  // Si es otro tipo de error, puedes capturarlo y lanzar un mensaje adecuado
  if (status === 403) {
    const message = data?.message || "Access denied";
    console.error("Error 403 - Forbidden:", message);
    // return Promise.reject(new Error(data?.message || 'Access denied'))
    return Promise.reject(new Error(message));
  }
  // Si es otro tipo de error, puedes capturarlo y lanzar un mensaje adecuado
  if (status === 404) {
    const message = data?.message || "Recurso no encontrado";
    console.log("Error 404 - Not Found:", message);

    return Promise.reject({
      code: 404,
      message: message,
      details: data,
    }); // return Promise.reject(new Error(data?.message || 'Resource not found'))
  }
  // Si es otro tipo de error, puedes capturarlo y lanzar un mensaje adecuado
  if (status === 500) {
    const message = data?.message || "Internal server error";
    console.error("Error 500 - Server Error:", message);
    return Promise.reject(new Error(message));
    // return Promise.reject(new Error(data?.message || 'Internal server error'))
  }
  // Propagar el error para que lo maneje el bloque catch en el componente
  return Promise.reject(error);
  // return Promise.reject(data || error)
};

axios.interceptors.request.use(request);
axios.interceptors.response.use(response, error);

// eslint-disable-next-line import/prefer-default-export
export const Http = async (
  method,
  endpoint,
  params = null,
  data,
  options = {},
) => {
  const defaultHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  if (!options.hasOwnProperty("headers")) {
    options.headers = defaultHeaders;
  }

  let serviceResponse = {};
  method = method.toLowerCase();

  try {
    const response = await axios({
      method,
      url: `${domain}${endpoint}`,
      params,
      data,
      headers: { ...defaultHeaders, ...options.headers },
      ...options,
    });

    serviceResponse = response.data;
  } catch (error) {
    // const customError = new Error();
    // customError.data = { message: error.data?.message || error.message };
    // throw customError;
    throw error;
  }
  return serviceResponse;
};
